import React, { FC } from 'react';
import { OutgoigMessagePayload } from '@go-shared/types/kafkaLogs';
import { KafkaOutgoingMessage } from './KafkaOutgoingMessage/KafkaOutgoingMessage';

export const KafkaOutgoingMessages: FC<{ messages: OutgoigMessagePayload[] }> = ({ messages }) => {
  return (
    <div className="content-minus-logo overflow-y-scroll">
      {messages.map((message, i) => (
        <KafkaOutgoingMessage {...message} key={i} />
      ))}
    </div>
  );
};
